module.exports = __webpack_public_path__ + "img/avatar.7c07b616.png";